const { __ } = wp.i18n;
const { Fragment } = wp.element;
const { MediaUpload, MediaUploadCheck } = wp.blockEditor;
const { Button, PanelRow, TextControl } = wp.components;
function BMediaUpload({ value, type = [], onSelect, placeholder }) {
  return (
    <div className="bMediaUpload">
      <Fragment>
        <MediaUploadCheck>
          <MediaUpload
            type={type}
            onSelect={(image) => onSelect(image.url)}
            render={({ open }) => <Button className="button button-primary" onClick={open} icon={"upload"}></Button>}
          />
        </MediaUploadCheck>
        <PanelRow className="width-100">
          <TextControl value={value} onChange={(fileUrl) => onSelect(fileUrl)} placeholder={placeholder} />
        </PanelRow>
      </Fragment>
    </div>
  );
}

export default BMediaUpload;
